import { useContext } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { DisplayContext } from '../../../../../../../components/gatekeeper'
import { SupplyWorkflow } from '../../../../../../../components/workflow-containers/supply'
import { ErrorCode } from '../../../../../../../constants'
import { RouteParams } from '../../../../../../../types/route'

export const Supply = () => {
  const { id } = useParams<RouteParams>()
  const { setError } = useContext(DisplayContext)
  if (!id) {
    setError(ErrorCode.NOT_FOUND_404)
    return null
  }
  return (
    <SupplyWorkflow recordId={id}>
      <Outlet />
    </SupplyWorkflow>
  )
}
